import React from "react";
import { Link } from "react-router-dom";

function Header() {
  return (
    <div>
      {/* Topbar Start - Using Official Contact Info */}
      <div className="container-fluid bg-dark px-5 d-none d-lg-block">
        <div className="row gx-0">
          <div className="col-lg-8 text-center text-lg-start mb-2 mb-lg-0">
            <div
              className="d-inline-flex align-items-center"
              style={{ height: 45 }}
            >
              <small className="me-3 text-light">
                <i className="fa fa-map-marker-alt me-2" />
                28-B Empress House, Empress Road, Lahore
              </small>

              <small className="me-3 text-light">
                <a
                  href="tel:+923214226147"
                  className="text-light text-decoration-none"
                >
                  <i className="fa fa-phone-alt me-2" />
                  +923214226147
                </a>
              </small>

              <small className="text-light">
                <a
                  href="mailto:allworldconsultancy@gmail.com"
                  className="text-light text-decoration-none"
                >
                  <i className="fa fa-envelope-open me-2" />
                  allworldrecruiting@gmail.com
                </a>
              </small>
            </div>
          </div>

          <div className="col-lg-4 text-center text-lg-end">
            <div
              className="d-inline-flex align-items-center"
              style={{ height: 45 }}
            >
              <a
                className="btn btn-sm btn-outline-light btn-sm-square rounded-circle me-2"
                href="https://www.facebook.com/p/All-World-Recruiting-Overseas-Employment-Agency-61556963541768/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-facebook-f" />
              </a>
              <a
                className="btn btn-sm btn-outline-light btn-sm-square rounded-circle"
                href="https://wa.me/923214226147"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-whatsapp" />
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Navbar Start */}
      <div className="container-fluid position-relative p-0">
        <nav className="navbar navbar-expand-lg navbar-light px-4 px-lg-5 py-3 py-lg-0 shadow-sm">
          <Link to="/" className="navbar-brand p-0">
            {/* --- LOGO OPTIMIZED --- */}
            <img
              src="assets/img/AWR-logo.png"
              alt="All World Recruiting Logo"
              style={{
                // Mobile height (default)
                maxHeight: "60px",
                width: "auto",
                filter: "drop-shadow(0px 2px 4px rgba(0,0,0,0.1))",
              }}
              // "max-height-lg-100" is a custom idea, but let's use a standard
              // responsive approach by adding a className
              className="py-1 logo-responsive"
            />
          </Link>

          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarCollapse"
          >
            <span className="fa fa-bars" />
          </button>

          <div className="collapse navbar-collapse" id="navbarCollapse">
            <div className="navbar-nav ms-auto py-0">
              <Link to="/" className="nav-item nav-link">
                Home
              </Link>
              <Link to="/About" className="nav-item nav-link">
                About
              </Link>
              <Link to="/Services" className="nav-item nav-link">
                Services
              </Link>
              <Link to="/Contact" className="nav-item nav-link">
                Contact
              </Link>
            </div>

            {/* CALL NOW BUTTON */}
            <a
              href="tel:+923214226147"
              className="btn btn-primary rounded-pill py-2 px-4 ms-lg-4"
            >
              Call Now
            </a>
          </div>
        </nav>
      </div>
    </div>
  );
}

export default Header;
